import React, { FC } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const UsersListContainer = React.lazy(
  () => import('../../containers/users-list/users-list.container')
);

const UserManagementContainer = React.lazy(
  () => import('../../containers/user-management/user-management.container')
);

const UserFormAddContainer = () => <UserManagementContainer mode="add" />;
const UserFormEditContainer = () => <UserManagementContainer mode="edit" />;

// Helper function to create protected route with consistent structure
const createProtectedRoute = (component: FC, addLayout = false): React.ReactElement => (
  <React.Suspense fallback={<div>Loading...</div>}>
    <DefaultLayout
      {...(addLayout && { addLayout })}
      authenticationRequired={true}
      permittedList={[UserRole.ADMIN, UserRole.E_COMMERCE_MANAGER]}
      component={component}
    />
  </React.Suspense>
);

const ROUTES = APP_ROUTES.USER_MANAGEMENT_MODULE.CHILDREN as RouteConfig;

export const UsersManagementRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={ROUTES.LIST.FULL_PATH} />
  },
  {
    path: ROUTES.LIST.FULL_PATH,
    element: createProtectedRoute(UsersListContainer)
  },
  {
    path: ROUTES.ADD.FULL_PATH,
    element: createProtectedRoute(UserFormAddContainer, true)
  },
  {
    path: ROUTES.EDIT.FULL_PATH,
    element: createProtectedRoute(UserFormEditContainer, true)
  }
];
